import { getDayOfWeek } from '@/utils/datetime';
import type { ScheduleFormData } from '@/schemas/schedule.schema';

const DEFAULT_BLOCKS = [{ startTime: '09:00', endTime: '17:00' }];

const EMPTY_FORM: ScheduleFormData = {
  validFrom: '',
  validTo: '',
  days: [],
  serviceIds: [],
};

export function buildDefaultScheduleFormData(defaultDate?: string): ScheduleFormData {
  if (!defaultDate) return EMPTY_FORM;
  const d = new Date(defaultDate);
  const dow = getDayOfWeek(d);
  return {
    validFrom: defaultDate,
    validTo: defaultDate,
    days: [{ dayOfWeek: dow, blocks: [...DEFAULT_BLOCKS] }],
    serviceIds: [],
  };
}
